<template>
  <div class="py-5">
    <div class="container">
      <h1 class="fw-light mb-4 text-poppins">
        {{ $t('blog_header') }} <span v-if="showPage">({{ $t('page') }} {{ currentPage + 1 }})</span>
      </h1>
      <div class="input-icon">
        <input v-model="search" type="search" class="form-control" placeholder="Search...">
        <span class="input-icon-addon">
          <i class="fa fa-search"></i>
        </span>
      </div>

      <div class="row mt-3">
        <div class="col-md-12 text-center p-5" v-if="loading">
          <i class="fa fa-spinner fa-spin fa-2x"></i>
        </div>
        <div class="col-md-4" v-for="(item, index) in posts" v-bind:key="`${index}_post`">
          <div class="card card-post card-round">
            <router-link :to="`/blog/${item.key}`">
              <img class="card-img-top" :src="item.image || defaultBanner" :alt="item.title">
            </router-link>
            <div class="card-body">
              <div class="d-flex">
                <div class="avatar">
                  <img :src="item.author ? item.author.profile_image : defaultImage" alt="..." class="avatar-img rounded-circle">
                </div>
                <div class="info-post ml-2">
                  <p class="username">{{ getAuthor(item) }}</p>
                  <p class="date text-muted">{{ moment.utc(item.publishing_date).format('LL') }}</p>
                </div>
              </div>
              <div class="separator-solid"></div>
              <!-- <p class="card-category text-info mb-1">
                <router-link :to="`/blog/${item.key}`">{{ moment(item.publishing_date).format('LL') }}</router-link>
              </p> -->
              <h3 class="card-title">
                <router-link :to="`/blog/${item.key}`">
                  {{ item.title }}
                </router-link>
              </h3>
              <p class="card-text">
                {{ getText(item) | truncate(180) }}
              </p>
              <router-link :to="`/blog/${item.key}`" class="btn btn-primary btn-rounded btn-sm">
                {{ $t('read_more') }}
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="clearfix">
        <div class="m-t-sm btn-group pull-right" v-if="!loading">
          <router-link :to="`/blog?page=${getPreviousPage() + 1}&search=${search || ''}`" class="btn btn-default" :disabled="currentPage == 1">
            <i class="fa fa-chevron-left"></i>
            <span class="ml-1" v-if="isCrawler">Previous Page</span>
          </router-link>
          <a href="#" class="btn btn-default">Page {{ currentPage + 1 }} of {{ getTotalPages() }}</a>
          <router-link :to="`/blog?page=${getNextPage()}&search=${search || ''}`"  class="btn btn-default" :disabled="currentPage >= getTotalPages()">
            <span class="mr-1" v-if="isCrawler">Next Page</span>
            <i class="fa fa-chevron-right"></i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Blog from '../services/blog'
import Filters from '../components/utils/filters'
import moment from 'moment'
import _ from 'underscore'

export default {
  name: 'Blog',
  data: function () {
    return {
      isCrawler: false,
      showPage: false,
      lang: '',
      search: '',
      loading: true,
      searchLimit: 9,
      currentPage: null,
      results: 0,
      totalArtists: 0,
      defaultImage: '/static/img/img-placeholder-dark.jpg',
      defaultBanner: '/static/img/blog/default-banner.jpg',
      posts: [],
      moment: moment
    }
  },
  methods: {
    setTitle: function () {
      let title = `Indiefy | ${this.$t('blog_title')}`

      if (this.$route.query.page) {
        title += ` - Page ${this.currentPage + 1}`
      }

      window.document.title = title
      window.$('meta[name="description"]').attr('content', this.$t('blog_description'))
      window.$('meta[property="og:description"]').attr('content', this.$t('blog_description'))
    },
    getAuthor: function (item) {
      let name = ''

      if (!item.author) {
        return 'Indiefy'
      }

      if (item.author.name) {
        name = item.author.name

        if (item.author.last_name) {
          name += ' ' + item.author.last_name
        }
      } else {
        name = item.author.username
      }

      return name
    },
    getText: function (item) {
      if (item.description) {
        return item.description
      } else {
        return window.$(item.content).text()
      }
    },
    getPreviousPage: function () {
      if (this.currentPage > 0) {
        return this.currentPage - 1
      } else {
        return 0
      }
    },
    getNextPage: function () {
      if ((this.currentPage + 1) >= this.getTotalPages()) {
        return this.getTotalPages()
      } else {
        return this.currentPage + 2
      }
    },
    getTotalPages: function () {
      return Math.ceil(this.totalArtists / this.searchLimit) || '1'
    },
    getPosts: function () {
      let filter = {
        published: 1,
        limit: this.searchLimit,
        search: this.search,
        page: this.currentPage
      }

      this.posts = []
      this.loading = true

      Blog.getAll(filter).then(response => {
        this.posts = response.data.items
        this.results = response.data.results
        this.totalArtists = response.data.total
        this.loading = false

        setTimeout(() => {
          window.prerenderReady = true
        }, 100)
      })
    }
  },
  watch: {
    search: _.debounce(function (value) {
      if (value !== undefined) {
        this.$router.push(`/blog?search=${this.search || ''}&page=${this.currentPage || ''}`)
      }
    }, 500),
    $route: function () {
      if (this.$route.query.page) {
        this.currentPage = parseInt(this.$route.query.page) - 1
      } else {
        this.currentPage = 0
      }

      this.showPage = this.$route.query.page

      if (this.$route.query.search) {
        this.search = this.$route.query.search
      }

      this.getPosts()
      this.setTitle()
    }
  },
  created: function () {
    this.search = this.$route.query.search
    this.isCrawler = navigator.userAgent.match(/bot|googlebot|prerender|crawler|spider|robot|crawling/i)

    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
    }

    if (this.lang !== 'en' && this.lang !== 'es') {
      window.$('link[rel="alternate"]').each((index, item) => {
        if (item.hreflang !== 'es' && item.hreflang !== 'en') {
          window.$(item).remove()
        }
      })

      this.lang = 'en'
    }

    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page) - 1
    } else {
      this.currentPage = 0
    }

    this.showPage = this.$route.query.page

    this.setTitle()
    this.getPosts()
  },
  filters: {
    truncate: Filters.truncate
  }
}
</script>
<style lang="scss" scoped>
.fa-spinner {
  color: #bbb;
}
</style>



// WEBPACK FOOTER //
// src/components/Blog.vue